export default __webpack_public_path__ + "27a850cd10f027e873d1f6a635c58094.png";